import { render, staticRenderFns } from "./gnb.vue?vue&type=template&id=1db16038&scoped=true&"
var script = {}
import style0 from "./gnb.vue?vue&type=style&index=0&id=1db16038&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db16038",
  null
  
)

export default component.exports